import {useDispatch} from 'react-redux';
import FetchResultWrapper from '../../../common/component/FetchResultWrapper';
import {Page} from '../../../common/constant/page';
import {showAuthModal} from '../../../common/function';
import useLogin from '../../../common/hook/useLogin';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import {useFetchInfo} from '../../../common/util/fetch';
import {routeTo} from '../../../common/util/PageRouter';
import {IBigContent} from '../../../commonSub/type';
import HomeFooter from '../../common/component/HomeFooter';
import {sendHomeEvent} from '../../common/tracking';
import TimeTableBigContentCardV4 from '../component/TimeTableBigContentCardV4';
import {actions, ActionType} from '../state/action';
import {
  ITimeTableKeywordHandler,
  ITimeTableLikeHandler,
  ITimeTablePage,
} from '../type';

interface IProps {
  page: ITimeTablePage;
}

export default function NewContentTableV4({page}: IProps) {
  const dispatch = useDispatch();
  const newContents = useTypedSelector(
    state => state.timeTable[page].newTabContents
  );
  const {isLogin} = useLogin();
  const {isLoading} = useFetchInfo(ActionType.FetchNewContents, page);

  const handleClick = ({id, sid}: IBigContent, index: number) => {
    routeTo({page: Page.Content, id, sid});
    sendHomeEvent({
      action: 'click',
      actionName: 'content',
      customProps: {
        content_id: id,
        event_layer: 'section',
        ordnum: index + 1,
      },
    });
  };

  const handleClickLike: ITimeTableLikeHandler = params => {
    if (isLogin) {
      dispatch(actions.fetchNewContentLike(params));
    } else {
      showAuthModal({isSaveReturnPage: true});
    }
    sendHomeEvent({
      action: 'click',
      actionName: 'content_favorite',
      customProps: {
        content_id: params.contentId,
        event_layer: 'section',
        ordnum: params.index + 1,
      },
    });
  };

  const handleClickKeyword: ITimeTableKeywordHandler = ({
    content: {id},
    keyword,
    index,
  }) => {
    routeTo({
      page: Page.ContentKeyword,
      keyword: encodeURIComponent(keyword),
    });
    sendHomeEvent({
      action: 'click',
      actionName: 'keyword',
      customProps: {
        content_id: id,
        content_keyword: keyword,
        event_layer: 'section',
        ordnum: index + 1,
      },
    });
  };

  return (
    <>
      <FetchResultWrapper
        showLoading={!newContents || isLoading}
        showNoItems={!newContents.length}
        noItemsProps={{textKey: 'schedule_empty'}}
      >
        <div className="flex flex-col gap-y-24">
          {newContents.map((content, index) => (
            <TimeTableBigContentCardV4
              key={content.id}
              index={index}
              content={content}
              className="flex flex-col gap-y-14"
              showLikeInfo={true}
              onClick={handleClick}
              onClickLike={handleClickLike}
              onClickKeyword={handleClickKeyword}
            />
          ))}
        </div>
      </FetchResultWrapper>
      <HomeFooter isBottomFixed={!newContents.length} />
    </>
  );
}
